export interface ShiftOccurrenceResponse {
  id: number;
  shiftId: string;
  shiftName: string;
  startUtc: string;
  endUtc: string;
  localDate: string;
  status: ShiftOccurrenceStatus;
  dueByUtc: string;
  workspaceTimeZone: string;
}

export enum ShiftOccurrenceStatus {
  Pending = 0,
  InProgress = 1,
  Completed = 2,
  Missed = 3,
}

export interface UpdateStatusRequest {
  status: ShiftOccurrenceStatus;
}
